import {getCustomerAccountAutosuggest} from '@account/api';
import {useQuery} from '@tanstack/react-query';

export const useCustomerAccountAutosuggest = (
  {limit = 8, search = '', status} = {},
  options = {}
) => {
  const params = {limit, search, status};

  // Keyed under the 'ims-accounts' root so a future invalidateQueries(
  // ['ims-accounts']) after a rename reaches the picker too, while staying
  // disjoint from the list endpoint's ['ims-accounts', params] entries.
  return useQuery(
    ['ims-accounts', 'autosuggest', params],
    () => getCustomerAccountAutosuggest(params),
    options
  );
};
